module.exports = __webpack_public_path__ + "static/media/icomoon.b13d80b7.eot";